import { createRoot } from 'react-dom/client';
import { resolveBootstrapApiUrl } from './api';
import { ChatWidget } from './ChatWidget';
import { GrowthWidget } from './GrowthWidget';
import {
  findEmbedScript,
  resolveGrowthWidgetId,
  resolvePublicKey,
} from './embed-script';
import widgetCss from './widget.css?inline';

const HOST_ID = 'revokonek-webchat-root';
const STYLE_ID = 'revokonek-webchat-styles';

function ensureStyles() {
  if (document.getElementById(STYLE_ID)) {
    return;
  }
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = widgetCss;
  document.head.appendChild(style);
}

function mount() {
  const widgetIdScript = document.querySelector('script[data-widget-id]');
  const script =
    widgetIdScript instanceof HTMLScriptElement
      ? widgetIdScript
      : findEmbedScript();
  const growthWidgetId = resolveGrowthWidgetId(script);
  const publicKey = resolvePublicKey(script);
  const mountKey = growthWidgetId || publicKey || '';

  if (!growthWidgetId && (!publicKey || publicKey === 'wc_live_replace_me')) {
    console.warn(
      '[Revocom Widget] Missing data-widget-id or data-public-key on the install script tag.',
    );
    return;
  }

  if (window.__revocomWidgetMounted === mountKey) {
    return;
  }
  if (
    window.__revocomWidgetMounted &&
    !growthWidgetId &&
    window.__revocomWidgetMounted !== mountKey
  ) {
    return;
  }

  window.__revocomWidgetMounted = mountKey;

  window.Revocom = {
    ...(window.Revocom ?? {}),
    widgetId: mountKey,
    apiUrl: resolveBootstrapApiUrl(script),
  };

  const existingHost = document.getElementById(HOST_ID);
  if (existingHost) {
    existingHost.replaceChildren();
  }

  ensureStyles();

  const host = existingHost ?? document.createElement('div');
  host.id = HOST_ID;
  if (!existingHost) {
    document.body.appendChild(host);
  }

  const root = createRoot(host);
  if (growthWidgetId) {
    root.render(<GrowthWidget publicId={growthWidgetId} />);
    return;
  }

  root.render(<ChatWidget widgetId={publicKey!} />);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
